import { customRequest, handleResponse, accountId } from "src/helpers";

const config = {
  apiUrl: process.env.VUE_APP_BACKEND_URL,
};

export const companyService = {
  getById,
  update,
  getAccount,
  downloadLogo,
  uploadLogo,
  accountId,
  updateCreditCard,
  updateACH,
};

function getById(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };
  return fetch(`${config.apiUrl}/Accounts/${id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function getAccount() {
  const requestOptions = {
    ...customRequest("GET"),
  };
  return fetch(`${config.apiUrl}/Accounts`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function update(payload) {
  const requestOptions = {
    ...customRequest("PUT", payload),
  };
  return fetch(`${config.apiUrl}/Accounts/${payload.id}`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function downloadLogo(id) {
  const requestOptions = {
    ...customRequest("GET"),
  };

  return fetch(
    `${config.apiUrl}/BlobFiles/${id}/download?isLogo=true`,
    requestOptions,
  );
}

function uploadLogo(payload) {
  const user = JSON.parse(localStorage.getItem("user"));

  const formData = new FormData();
  formData.append("File", payload.file, payload.filename);

  const url = `${config.apiUrl}/BlobFiles/upload/logo`;
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + user.token,
      Charset: "utf-8",
    },
    body: formData,
  };
  return fetch(url, requestOptions)
    .then((r) => r.json())
    .then((data) => {
      return data;
    });
}

// function updateCreditCard(payload) {
//   const requestOptions = {
//     ...customRequest("POST"),
//     body: JSON.stringify({
//       token: payload.token,
//       expirationMonth: payload.expirationMonth,
//       expirationYear: payload.expirationYear,
//       cardType: payload.cardType,
//       lastFour: payload.lastFour,
//       firstName: payload.firstName,
//       lastName: payload.lastName,
//       companyName: payload.companyName,
//       postalCode: payload.postalCode,
//     }),
//   };
//   return fetch(
//     `${config.apiUrl}/Accounts/UpdatePaymentMethodCardPointeCredit`,
//     requestOptions,
//   )
//     .then(handleResponse)
//     .then((response) => {
//       return {
//         data: response,
//       };
//     });
// }

function updateCreditCard(payload) {
  const body = {
    token: payload.token,
    expirationMonth: payload.expirationMonth,
    expirationYear: payload.expirationYear,
    cardType: payload.cardType,
    lastFour: payload.lastFour,
    postalCode: payload.postalCode,
  };

  if (payload.companyName) {
    body.companyName = payload.companyName;
  } else {
    body.firstName = payload.firstName;
    body.lastName = payload.lastName;
  }

  const requestOptions = {
    ...customRequest("POST"),
    body: JSON.stringify(body),
  };

  return fetch(
    `${config.apiUrl}/Accounts/UpdatePaymentMethodCardPointeCredit`,
    requestOptions,
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

function updateACH(payload) {
  const body = {
    token: payload.token,
    firstName: payload.firstName,
    lastName: payload.lastName,
    companyName: payload.companyName,
    postalCode: payload.postalCode,
    lastFour: payload.lastFour,
    accountType: payload.accountType,
  };

  if (payload.companyName) {
    body.companyName = payload.companyName;
  } else {
    body.firstName = payload.firstName;
    body.lastName = payload.lastName;
  }

  const requestOptions = {
    ...customRequest("POST"),
    body: JSON.stringify(body),
  };
  return fetch(
    `${config.apiUrl}/Accounts/UpdatePaymentMethodCardPointeACH`,
    requestOptions,
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}
